
import React from 'react';

import {randomChoice} from './utils.js';

import './SelectionTextBox.css';

class TextBoxSelection extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <li>
                {this.props['value']}
                <div onClick={event => {event.stopPropagation(); this.props['onremove'](this.props['value'])}}>&times;</div>
            </li>
        );
    }
}

class SelectionTextBoxSuggestions extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const suggestions = this.props['suggestions'];
        let suggestions_jsx = "";
        let cls = "textbox-suggestions";
        const max_options = 8;
        let options_overflow = false;

        if (suggestions['type'] == 'enum') {
            let options = [...suggestions['options']];
            if (options.length > max_options) {
                options_overflow = true;
                let keep_options = [];
                for (let idx = 0; idx < max_options; idx++) {
                    const opt = randomChoice(options)
                    keep_options.push(opt);
                    options = options.filter(el => el != opt);
                }
                options = keep_options;
                options.sort();
            }

            suggestions_jsx = options.map(sugg => <p key={sugg}>{sugg}</p>);

            if (options.length == 0) {
                cls += " invalid";
            }
        }
        else if (suggestions['type'] == 'number') {
            let str = "[Number]";
            if (suggestions['units'] != '') {
                str += ' ' + suggestions['units'];
            }

            suggestions_jsx = <p>{str}</p>;
        }
        else if (suggestions['type'] == 'string') {
            let str = "[String]";

            suggestions_jsx = <p>{str}</p>;
        }

        let tab_complete_jsx = "";
        if (this.props['suggestions']['autocomplete'] !== null) {
            tab_complete_jsx = <span style={{'marginLeft': '2px'}}>TAB to complete</span>;
        }

        let overflow_jsx = "";
        if (options_overflow) {
            overflow_jsx = <span style={{'marginLeft': '2px'}}>and others ...</span>;
        }

        return (
            <div className={cls} style={{'width': this.props['width'] + 'px'}}>
                <span style={{'paddingTop': '3px', 'paddingBottom': '3px'}}>Suggestions:</span>
                {suggestions_jsx}
                {tab_complete_jsx}
                {overflow_jsx}
            </div>
        );
    }
}

class SelectionTextBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            'suggestions': null,
            'can_press_enter': false
        }

        this.handleInput = this.handleInput.bind(this);
        this.removeSelection = this.removeSelection.bind(this);
        this.max_selections = this.props['max_selections'] !== undefined ? this.props['max_selections'] : 1;
    }

    handleInput() {
        this._updateSuggestions();
        this.setState({'can_press_enter': (this.props['parser'](this.text_box.value) !== null)});
    }

    removeSelection(sel) {
        let selections = this.props['content']
        selections = selections.filter(s => {
            if (typeof s === 'object') {
                s = s.display;
            }
            return s !== sel;
        });

        this.props['onselectionupdate'](selections);
    }

    onfocus() {
        this.text_box.focus();
        this._updateSuggestions();
    }

    onblur() {
        this.setState({'suggestions': null});
    }

    onkey(event) {
        if (this.props['suggestion_callback'] !== undefined && event.keyCode == 9) {
            event.nativeEvent.preventDefault();
            if (this.state['suggestions']['autocomplete'] !== null) {
                this.text_box.value = this.state['suggestions']['autocomplete'];

                this._updateSuggestions();
            }
        }
        else if (event.keyCode == 13) {
            const parsed_val = this.props['parser'](this.text_box.value);

            if (parsed_val !== null) {
                let selections = this.props['content'].concat([parsed_val]);
                if (selections.length > this.max_selections) {
                    selections.shift();
                }

                this.text_box.value = '';

                this._updateSuggestions();
                this.setState({'can_press_enter': false});
                this.props['onselectionupdate'](selections);
            }
        }
    }

    _updateSuggestions() {
        if (this.props['suggestion_callback'] !== undefined) {
            const suggestions = this.props['suggestion_callback'](this.text_box.value);
            this.setState({'suggestions': suggestions});
        }
    }

    render() {
        let selection_list = (
            <ul ref={el => this.select_list = el}>
                {this.props['content'].map(s => {
                    let display = s;
                    if (typeof display === 'object') {
                        display = display.display;
                    }
                    return <TextBoxSelection key={display} value={display} onremove={this.removeSelection}/>;
                })}
            </ul>
        );

        if (this.props['content'].length == 0) {
            selection_list = (
                <ul ref={el => this.select_list = el}>
                    {<li className='dummy'>.</li>}
                </ul>
            );
        }

        const width = this.props['width'] !== undefined ? this.props['width'] : 500;

        let suggestions_box = "";
        let cls = "selectiontextbox";
        if (this.state['suggestions'] !== null) {
            suggestions_box = <SelectionTextBoxSuggestions
                                suggestions={this.state['suggestions']}
                                width={width-2}
                                >
                                </SelectionTextBoxSuggestions>;

            if (this.state['suggestions']['type'] == 'enum' && this.state['suggestions']['options'].length == 0) {
                cls += " invalid";
            }
        }

        let enter_prompt = "";
        if (this.state['can_press_enter']) {
            enter_prompt = <span>Press ENTER to apply</span>;
        }

        return (
            <div className={cls} onClick={this.onfocus.bind(this)} style={{'width': width + 'px'}}>
                {selection_list}
                <input
                    ref={el => this.text_box = el}
                    type="text"
                    placeholder={this.props['placeholder']}
                    onInput={this.handleInput}
                    onBlur={this.onblur.bind(this)}
                    onKeyDown={this.onkey.bind(this)}
                />
                {enter_prompt}
                {suggestions_box}
            </div>
        );
    }
}

export default SelectionTextBox;